import request from '../index.js'

// 任务管理API
export const taskApi = {
  // 获取任务列表
  getTasks(params) {
    const { page = 1, size = 10, pageSize, status, taskType, publisherId, title } = params || {}
    const actualSize = size || pageSize || 10
    const queryParams = { page, size: actualSize }
    if (status) queryParams.status = status
    if (taskType) queryParams.taskType = taskType
    if (publisherId) queryParams.publisherId = publisherId
    if (title) queryParams.title = title
    
    return request({
      url: '/admin/tasks',
      method: 'get',
      params: queryParams
    })
  },

  // 获取任务详情
  getTaskById(id) {
    return request({
      url: `/admin/tasks/${id}`,
      method: 'get'
    })
  },

  // 创建任务
  createTask(data) {
    return request({
      url: '/admin/tasks',
      method: 'post',
      data
    })
  },

  // 更新任务
  updateTask(id, data) {
    return request({
      url: `/admin/tasks/${id}`,
      method: 'put',
      data
    })
  },

  // 删除任务
  deleteTask(id) {
    return request({
      url: `/admin/tasks/${id}`,
      method: 'delete'
    })
  },

  // 更新任务状态
  updateTaskStatus(id, status) {
    return request({
      url: `/admin/tasks/${id}/status`,
      method: 'put',
      data: { status }
    })
  },

  // 获取任务统计
  getTaskStats() {
    return request({
      url: '/admin/tasks/stats',
      method: 'get'
    })
  },

  // 获取任务参与记录
  getTaskParticipants(taskId, params) {
    return request({
      url: `/tasks/${taskId}/participants`,
      method: 'get',
      params
    })
  },

  // 审核任务完成
  reviewTask(taskId, data) {
    return request({
      url: `/tasks/${taskId}/review`,
      method: 'post',
      data
    })
  }
}

export default taskApi
